// External
import { createStore, applyMiddleware, compose } from 'redux'
import {routerMiddleware} from 'react-router-redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import Immutable from 'immutable';
// Internal
import rootReducer from './rootReducer'
import {loadReduxLocalStorageState, saveReduxStateToLocalStorage} from './reduxLocalStorage';

import {apiUrl} from '/app/src/ENV'

import { registerInitialStoreState, registerMiddlewares, buildInitialStoreState } from 'redux-actions-assertions';

const history = createHistory()
//User gets pushed into startpage at refresh. This is to avoid issues with
//mounting/initial data issues when reloading app subpages.


/* Create enhanced history object for router */
// ==============   =STORE=================
let persistedState = loadReduxLocalStorageState();
persistedState = persistedState? persistedState: Immutable.Map();
//persistedState = Immutable.Map();
//let initialState = Immutable.fromJS({
//    'system': {
//        'api': 'https://api.jibber.social'
//    }}).merge(persistedState)
let initialState = persistedState.setIn(['system', 'api'], apiUrl)

const enhancers = []
const middleware = [
  thunk,
  routerMiddleware(history)
]

const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__
if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
}
const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)
const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
)


// ======== redux-actions-assertions jest test ==========
registerMiddlewares(middleware);
registerInitialStoreState(initialState);

// to set custom initial state
// to generate initial state of your application
registerInitialStoreState(buildInitialStoreState(rootReducer));

// ==============HISTORY ================

store.subscribe(() => {
    const propsToDiscard = [
        'conversation',
        //'routing',
        'notification',
        //'user',
        'quickResponse',
        'network',
        'employee',
        'system',
        'faq',
        'automessage',
        'company',
        'tutorial',
        'customer'
    ];
    saveReduxStateToLocalStorage(store.getState(), propsToDiscard);
    //TODO investigate if we remove local storage once we get the props. It might leak if we
    // logout or reset without remove it.
})

export {store, history}



// WEBPACK FOOTER //
// ./src/store/store.js